export function ExternalLinkIcon({
    className = "h-4 w-4",
}: {
    className?: string;
}) {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={className}
          aria-hidden="true"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
          <polyline points="15 3 21 3 21 9" />
          <line x1="10" y1="14" x2="21" y2="3" />
        </svg>
        // <svg
        //     viewBox="0 0 24 24"
        //     className={className}
        //     xmlns="http://www.w3.org/2000/svg"
        //     aria-hidden="true"
        //     focusable="false"
        // >
        //     <g transform="matrix(1.11 0 0 1.11 12 12)">
        //         <path
        //             transform="translate(-12, -12)"
        //             d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 12 L 19 12 L 19 19 L 5 19 L 5 5 L 12 5 L 12 3 L 5 3 z M 14 3 L 14 5 L 17.585938 5 L 8.2929688 14.292969 L 9.7070312 15.707031 L 19 6.4140625 L 19 10 L 21 10 L 21 3 L 14 3 z"
        //             fill="currentColor"
        //             fillRule="nonzero"
        //         />
        //     </g>
        // </svg>
    );
}
